import { IMask } from 'react-imask'

const IINMask = IMask.createMask({
  mask: [
    {
      mask: '000000000000'
    }
  ]
})

const IBANMask = IMask.createMask({
  mask: [
    {
      mask: 'aa 00 000000 00000 00000000000000',
      prepare: function (str: string) {
        return str.toUpperCase()
      },
      definitions: {
        a: /^[a-zA-Z]+$/
      }
    }
  ]
})

const createNumberWithUnitMask = ({
  min,
  max,
  unit,
  thousandsSeparator = ''
}: {
  min?: number
  max?: number
  unit?: string
  thousandsSeparator?: string
}) => {
  return [
    { mask: '' },
    {
      mask: unit ? `num ${unit}` : 'num',
      lazy: false,
      expose: true,
      blocks: {
        num: {
          mask: Number,
          expose: true,
          thousandsSeparator,
          min,
          max
        }
      }
    }
  ]
}

const letterRegex = /^[a-zA-Z]+$/

const PhoneMask = '+{7} (000) 000 00 00'

export { createNumberWithUnitMask, IBANMask, IINMask, letterRegex, PhoneMask }
